// extracted by mini-css-extract-plugin
export default {"value":"Options_value__KT57W","name":"Options_name__74XKa","icon":"Options_icon__SNIVO"};